export default __webpack_public_path__ + "static/media/EM1930.34I-42982_-25688_0.bf3874ec.jpg";